module.exports = __webpack_public_path__ + "static/media/sg14cr923.c301b0e3.jpg";